// extracted by mini-css-extract-plugin
module.exports = {"grid":"alumni-module--grid--3ksHB"};